import { loadState } from './localStorage';
import { defaultState } from './../reducers/defaultState';
import { getProcessedGeoJson } from './../actions/geoJson';

const persistedState = loadState() || {};
const preloadedState = {};

for(let key in defaultState){
  preloadedState[key] = {
    ...defaultState[key],
    ...persistedState[key]
  };
}

const { mapGeoJson } = preloadedState.storage;

if(mapGeoJson) {
  const processedGeoJson = getProcessedGeoJson(mapGeoJson);
  for(let key in processedGeoJson) {
    if(preloadedState.geoJsonData.hasOwnProperty(key)) {
      preloadedState.geoJsonData[key] = processedGeoJson[key];
    }else if(preloadedState.session.hasOwnProperty(key)) {
      preloadedState.session[key] = processedGeoJson[key];
    }
  }
}

export const savedState = preloadedState;



// WEBPACK FOOTER //
// ./src/store/savedState.js